import { BASE_CITIES_URL, CITIES_URL, COUNTRY_ID, QUERY, REGION_ID } from "../constants/citiesAPI";
import { METHOD_GET } from "../constants/common";

const doGetRequest = (
    path: string,
    searchParams?: Record<string, any>,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
) => {
    const url = new URL(path, BASE_CITIES_URL);
    searchParams &&
        Object.entries(searchParams).forEach(params => {
            url.searchParams.append(params[0], params[1].toString());
        });
    return fetch(url, {
        method: METHOD_GET,
    })
        .then(response => response.json())
        .then((json: any) => {
            return callback ? callback(json.data) : json;
        })
        .catch((err: any) => (errorCallback ? errorCallback(err) : Promise.reject(err)));
};

export const getCitiesList = (
    query?: string,
    countryId?: number,
    regionId?: number,
    callback?: (resp: Array<any>) => any,
    errorCallback?: (resp: any) => void,
) =>
    doGetRequest(
        CITIES_URL,
        {
            [QUERY]: query,
            [COUNTRY_ID]: countryId || 1,
            [REGION_ID]: regionId || 0,
        },
        callback,
        errorCallback,
    );
